import {
    SELECTED_ANNOUNCEMENT_FILTER,
    

} from "../actions";

export const announcementFiter = (state = false, action) => {

    switch (action.type) {
      case SELECTED_ANNOUNCEMENT_FILTER:
        return action.payload;
  
      default:
  
        return state;
  
    }
  
};